<template>
  <div>
    <section class="p-box">
      <header class="p-box__header">
        <div class="filter__wrapper p-filtersA">
          <div class="p-filtersA__left">
            <p />
          </div>
          <div class="p-filtersA__right">
            <router-link :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid}, query: {tab: 'product'} }" class="noUnderline">
              <button class="backButton c-button__item c-button__item--outline">
                {{ $t('labels.backToPreviousPage') }}
              </button>
            </router-link>
          </div>
        </div>
      </header>
      <div class="p-box__body">
        <div class="p-products">
          <Loading v-show="loading" />
          <template v-if="!loading">
            <div v-if="product.gmbSyncResult.status === 'failed'" class="failedInfo">
              <div class="failedInfo__msg">
                <p>{{ $t('pages.CompaniesLocationStoreProductDetail.error.title') }}</p>
              </div>
              <Info alert>
                <p>
                  {{ $t('pages.CompaniesLocationStoreProductDetail.error.failedInfo1') }}<br>
                  {{ $t('pages.CompaniesLocationStoreProductDetail.error.failedInfo2') }}
                </p>
              </Info>
            </div>
            <div class="p-products__item">
              <div class="p-products__header">
                <div
                  class="p-photos__image"
                >
                  <div :style="{ 'background-image': `url(${ product.image })` }" />
                </div>
              </div>
              <div class="p-products__summary">
                <div class="p-products__name">
                  {{ product.title }}
                </div>
                <div class="p-products__category">
                  {{ product.categoryName }}
                </div>
                <div class="p-products__description">
                  {{ product.description }}
                </div>
                <div v-if="product.price" class="fontBold">
                  {{ numberLocaleString(product.price.value) }}円
                </div>
              </div>
              <div class="p-products__summary">
                <div class="p-products__content">
                  <p class="statusMsg" :class="{ 'statusMsg__failed': product.gmbSyncResult.status === 'failed' }">
                    <span v-if="product.gmbSyncResult.status !== 'unset'"
                          :class="`statusMark__${product.gmbSyncResult.status}`"
                          class="statusMark"
                    />
                    {{ statusMsg() }}
                  </p>
                </div>
                <template v-if="showMoreThanEditorAuthority">
                  <div class="p-products__action">
                    <button class="c-button__item c-button__item--outline" @click.prevent="handleDeleteProductStore">{{ $t('pages.CompaniesLocationStoreProductDetail.delete') }}</button>
                  </div>
                  <div class="p-products__info">
                    <div class="c-info">
                      <div class="c-info__icon">
                        <Icon name="iconQuestion" />
                      </div>
                      <div class="c-info__content">
                        <p>{{ $t('pages.CompaniesLocationStoreProductDetail.deleteInfo1') }} </p>
                        <p>{{ $t('pages.CompaniesLocationStoreProductDetail.deleteInfo2') }} </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Icon from '../components/Icon.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { toNumberLocaleString } from '../modules/localeString'
import Loading from '../components/Loading.vue'
import Info from '../components/Info.vue'

export default {
  name: 'CompaniesStoreProduct',
  components: {
    Icon,
    Info,
    Loading,
  },
  computed: {
    ...mapState({
      product: state => state.companiesProduct.data,
      loading: state => state.companiesProduct.loading,
      productStores: state => state.companiesProduct.data.productStores,
    }),
    ...mapGetters({
      showMoreThanEditorAuthority: 'companiesAccessibleApi/showMoreThanEditorAuthority',
    }),
    companyUuid() {
      return this.$route.params.company_uuid
    },
    storeUuid() {
      return this.$route.params.store_uuid
    },
    productId() {
      return this.$route.params.id
    },
  },
  created() {
    this.readProduct()
  },
  methods: {
    ...mapActions({
      readProduct: 'companiesProduct/readProduct',
      deleteProductStore: 'companiesProduct/deleteProductStore',
    }),
    handleDeleteProductStore() {
      const targetStores = this.productStores.filter((store) => store.uuid === this.storeUuid)

      if(targetStores.length === 1) {
        const targetStore = targetStores[0]

        if (confirm(this.$t('pages.CompaniesLocationStoreProduct.deleteConfirm'))) {
          this.deleteProductStore(targetStore.id)
          this.$router.push({ name: 'CompaniesLocationStore', params: { company_uuid: this.companyUuid, store_uuid: this.storeUuid }, query: { tab: 'product' } })
        }
      }
    },
    statusMsg() {
      if (this.product.gmbSyncResult.status === 'failed') {
        return this.$t('pages.CompaniesProducts.status.' + this.product.gmbSyncResult.status, { count: this.product.gmbSyncResult.errorCount })
      }

      if (this.product.gmbSyncResult.status === 'store_coordination_cancellation') {
        return this.$t('pages.CompaniesProducts.status.store_coordination_cancellation', { count: this.product.gmbSyncResult.coordinationCancellationStoreCount })
      }
      return this.$t('pages.CompaniesProducts.status.' + this.product.gmbSyncResult.status)
    },
    /**
     * 数値の3桁区切り
     * @param  { Number } value
     * @return { Number }
     */
    numberLocaleString(value) {
      return toNumberLocaleString(value)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.fontBold {
  font-weight: bold;
}
.p-products{
  &__item {
    display: flex;
    padding: 20px;
    border: 1px solid #e4e7eb;
    border-radius: 4px;
    margin-bottom: 15px;
  }
  &__header {
    width: 20%;
    margin-right: 28px;
  }
  &__summary {
    width: 45%;
  }
  &__summary:not(:last-child) {
    margin-right: 28px;
  }
  &__content {
    width: 45%;
    margin-bottom: 20px;
  }
  &__action {
    width: 45%;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  &__info {
    width: 45%;
    width: 320px
  }
  &__name {
    margin-top: 10px;
    font-weight: bold;
  }
  &__description {
    margin: 10px 0;
  }
}
.link {
  display: inline-block;
  margin-top: 16px;
  padding: 8px 24px;
  color: #3A3B3F;
  background: #EEEEEE;
  border-radius: 4px;
  text-decoration: none;
}
.actionButton {
  border-radius: 4px;
  display: inline-block;
  width: 130px;
  height: 24px;
  border: 1px solid;
  text-align: center;
  color: #3A3B3F;
}
.statusMark {
  border-radius: 50%;
  display: inline-block;
  width: 8px;
  height: 8px;
  &__failed {
    background: $color-accent-primary;
  }
  &__synced {
    background: $complete-color;
  }
  &__syncing {
    background: #D2D5DB;
  }
  &__deleting {
    background: #D2D5DB;
  }
  &__store_coordination_cancellation{
    background: #D2D5DB;
  }
}
.statusMsg__failed {
  color: $color-accent-primary;
}
.failedInfo {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.failedInfo__msg {
  color: #E9446A;
  font-weight: bold;
  margin-bottom: 5px;
}
.noUnderline{
  text-decoration: none;
}
</style>
